import React from "react";

import { LinearProgress } from "@sessionboard/material-ui/Progress";

import css from "./styles.scss";

import CSSModules from "react-css-modules";

const LinearProgressWithLabel = ({ value, cancel }) => {
  return (
    <div styleName="progressContainer">
      <div styleName="progressBarContainer">
        <LinearProgress variant="determinate" value={value} />
      </div>

      <div styleName="labelContainer">{`${Math.round(value)}%`}</div>
      <i
        styleName="closeIcon"
        className="material-symbols-outlined"
        onClick={cancel}
      >
        close
      </i>
    </div>
  );
};

export default CSSModules(LinearProgressWithLabel, css);
